import React from "react";
import { Box, Button, Text } from "@chakra-ui/react";
import { useToast } from "duck";
import Form from "../../../form";
import { TextInput } from "../../../inputs";
import Modal from "../../Modal";
import { FormValues, getValidationSchema } from "./duck";

interface ModalProps {
  isOpen: boolean;
  onClose(): void;
  title: string;
  description: string;
  onExport(email: string): Promise<any>;
  defaultValue?: string;
}

const Export: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  description,
  onExport,
  defaultValue
}) => {
  const toast = useToast({ status: "success" });

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <Form<FormValues>
        onSubmit={values =>
          onExport(values.recipientEmail).then(() => {
            onClose();
            toast({
              description: `Case data is exported to ${values.recipientEmail} email address successfully.`
            });
          })
        }
        {...getValidationSchema(defaultValue)}
      >
        <Box py={6}>
          <Text mb={2} color="black" fontWeight="medium">
            {description}
          </Text>
          <TextInput
            placeholder="Email"
            type="email"
            name="recipientEmail"
            label="Email"
            labelHidden
          />
        </Box>
        <Form.Controls submitText="Export">
          <Button variant="outline" colorScheme="gray" onClick={onClose}>
            Cancel
          </Button>
        </Form.Controls>
      </Form>
    </Modal>
  );
};

export default Export;
